// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#obtainLicense{color:#333;text-align:center}h1{font-size:36px}h2{font-size:27px}.control-label,.form-control,p{font-size:18px}.form-control{color:#333;height:40px}.form-horizontal .control-label{padding-top:8px}", ""]);
// Exports
module.exports = exports;
